import { render, staticRenderFns } from "./OpenDateManageView.vue?vue&type=template&id=4da8cddd&scoped=true&"
import script from "./OpenDateManageView.vue?vue&type=script&lang=js&"
export * from "./OpenDateManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da8cddd",
  null
  
)

export default component.exports